import React, { useMemo, useEffect, useState, useContext } from 'react';
import { ClockContext } from './ClockContext';

const digitCells = [
  { digit: 0, cells: [ 0, 0, 0, 0, 0, 0, 0, 0, 0 ] },
  { digit: 1, cells: [ 1, 0, 0, 0, 0, 0, 0, 0, 0 ] },
  { digit: 2, cells: [ 1, 1, 0, 0, 0, 0, 0, 0, 0 ] },
  { digit: 3, cells: [ 1, 1, 1, 0, 0, 0, 0, 0, 0 ] },
  { digit: 4, cells: [ 1, 1, 1, 0, 0, 1, 0, 0, 0 ] },
  { digit: 5, cells: [ 1, 1, 1, 0, 0, 1, 0, 0, 1 ] },
  { digit: 6, cells: [ 1, 1, 1, 0, 0, 1, 0, 1, 1 ] },
  { digit: 7, cells: [ 1, 1, 1, 0, 0, 1, 1, 1, 1 ] },
  { digit: 8, cells: [ 1, 1, 1, 1, 0, 1, 1, 1, 1 ] },
  { digit: 9, cells: [ 1, 1, 1, 1, 1, 1, 1, 1, 1 ] },
];

const discoColors = [
  '#0200E8',
  '#9B00FF',
  '#FF00B9',
  '#FFF800',
  '#18FF00',
  '#FB0000',
];

const DigitGrid = ( { value } ) => {

  const { color, disco } = useContext(ClockContext);

  const thisCell = useMemo(() => {
    return digitCells.find(cell => cell.digit === parseInt(value));
  }, [ value ]);

  const [ cellColors, setCellColors ] = useState(Array(9).fill(undefined));

  useEffect(() => {
    if (!disco || !thisCell) {
      return;
    }

    setCellColors(prev => prev.map(( cellColor, cellValue ) => {
      if (thisCell.cells[cellValue] === 1 && !cellColor) {
        return getColor();
      }
      if (thisCell.cells[cellValue] === 0) {
        return undefined;
      }
      return cellColor;
    }));
  }, [ value, disco, thisCell ]);

  const getColor = () => {
    return discoColors[Math.floor(Math.random() * discoColors.length)];
  };

  return (
    <div className="digit-grid">
      {[ ...Array(9) ].map(( _, i ) => (
        <div
          key={i}
          className={`digit-cell ${thisCell && thisCell.cells[i] === 1 ? 'active' : ''}`}
          style={thisCell && thisCell.cells[i] === 1 ? { backgroundColor: disco ? cellColors[i] : color } : undefined}
        ></div>
      ))}
    </div>
  );
};

export default DigitGrid;